import React, { useState } from "react";
import skillsData from "../../constants/skillsData";
import "./TechstackComponent.css";

const TechstackComponent = () => {
  const [isOpenSkills, setIsOpenSkills] = useState(
    skillsData.map((_, index) => index === 0),
  );

  const toggleSkills = (index) => {
    setIsOpenSkills((prevIsOpenSkills) =>
      prevIsOpenSkills.map((_, i) =>
        i === index ? !prevIsOpenSkills[index] : false,
      ),
    );
  };
  return (
    <>
      <div className="skills__container container grid" id="skillsContainer">
        {skillsData.map((skill, index) => (
          <div
            key={index}
            className={`skills__content ${
              isOpenSkills[index] ? "skills__open" : "skills__close"
            } reveal`}
          >
            <div className="skills__header" onClick={() => toggleSkills(index)}>
              <i className={`${skill.headerIcon} skills__icon`}></i>
              <div>
                <h1 className="skills__title">{skill.headerTitle}</h1>
                <span className="skills__subtitle">{skill.headerSubtitle}</span>
              </div>
              <i className="fa-sharp fa-solid fa-chevron-down skills__arrow"></i>
            </div>
            <div className="skills__list">
              {skill.skills.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className={`skills__titles ${
                    item.icon ? "" : "skills__titles_extended"
                  }`}
                >
                  {item.icon ? (
                    <div className="skill-card">
                      <a
                        href={item.url || "#"}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={item.icon} alt={`${item.name} Icon`} />
                      </a>
                    </div>
                  ) : (
                    <h3 className="skills__name">
                      {item.url ? (
                        <a href={item.url} target="_blank" rel="noreferrer">
                          {item.name}
                        </a>
                      ) : (
                        <span>{item.name}</span>
                      )}
                    </h3>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TechstackComponent;
